import posthog from 'posthog-js'
import { sessionManager } from './sessionManager'

const UNAUTHENTICATED_CODES = ['UNAUTHORIZED', 'INVALID_TOKEN', 'SESSION_EXPIRED']

export const defaultRequestInterceptor = async (config) => {
    // Check if session is expired before making request
    if (sessionManager.isExpired() && !sessionManager.isEmpty()) {
        sessionManager.clear()
    }

    try {
        config.params = { ...config.params, ts: Date.now() }
    } catch (e) {}
    return config
}

export const defaultResponseInterceptor = (response) => {
    const expiresAt = response.headers['x-session-expires-at']
    if (expiresAt) {
        sessionManager.updateExpiration(expiresAt)
        sessionManager.markActiveThisSession()
    }
    try {
        if (response.data.redirect) {
            if (response.data.redirect == '/login') {
                sessionManager.clear()
                window.location.href = `${response.data.redirect}?redirect=${encodeURIComponent(
                    window.location.pathname + window.location.search
                )}`
                return
            }
            window.location.href = response.data.redirect
        }
    } catch (e) {}
    try {
        if (response.data.events) {
            response.data.events.forEach((event) => {
                window.dataLayer.push({ event: event.name, ...event })
            })

            if (!posthog._isIdentified() && response.data.events[0].params.user_id) {
                posthog.identify(response.data.events[0].params.user_id)
            }
        }
    } catch (e) {}

    try {
        response?.data?.rulerEvent && RulerAnalytics.trackConversionAsync(response?.data?.rulerEvent, '', '', 500)
    } catch (e) {}
    return response
}

export const defaultErrorInterceptor = (error) => {
    try {
        response?.data?.rulerEvent && RulerAnalytics.trackConversionAsync(response?.data?.rulerEvent, '', '', 500)
    } catch (e) {}
    try {
        // Don't clear session for MFA challenges - these are expected 401s
        if (UNAUTHENTICATED_CODES.includes(error.response.data?.code)) {
            sessionManager.clear()
        }
    } catch (e) {}
    try {
        if (error.response.data.redirect) {
            window.location.href = error.response.data.redirect
        }
    } catch (e) {}
    try {
        if (error.response.data.events) {
            error.response.data.events.forEach((event) => {
                window.dataLayer.push({ event: event.name, ...event })
            })
        }
    } catch (e) {}

    return Promise.reject(error)
}
